module.exports = __webpack_public_path__ + "static/media/mediaListIconInactive.52fd6f53.svg";